import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DeleteAccountPage = () => {
  return (
    <div className="min-h-screen bg-audioyou-bg">
      <header className="neumorphic-header sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-audioyou-accent flex items-center justify-center">
                <span className="text-white text-xl">🎙️</span>
              </div>
              <span className="text-xl font-bold text-gray-800">AudioToo</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="neumorphic-button-small inline-flex items-center gap-2 px-3 py-2 mb-6">
          <ArrowLeft size={16} />
          <span>Volver</span>
        </Link>

        <div className="neumorphic-card p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-8">Eliminación de cuenta y datos</h1>

          <div className="prose prose-gray max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Cómo solicitar la eliminación de tu cuenta</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                Si quieres eliminar tu cuenta de AudioToo y todos los datos asociados, sigue estos pasos:
              </p>
              <ol className="list-decimal list-inside text-gray-600 space-y-2">
                <li>Envía un correo electrónico a{' '}
                  <a href="mailto:privacy@audiotoo.com" className="text-audioyou-accent hover:underline">
                    privacy@audiotoo.com
                  </a>{' '}
                  desde la dirección de email asociada a tu cuenta (la misma con la que inicias sesión con Google).
                </li>
                <li>Indica en el asunto «Eliminar mi cuenta» y en el cuerpo tu nombre de usuario de AudioToo.</li>
                <li>Confirmaremos tu identidad respondiendo a ese mismo correo y procesaremos la eliminación.</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Qué datos se eliminan</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Tu cuenta de usuario (nombre, email y foto de perfil obtenidos de Google).</li>
                <li>Todos los audios que hayas grabado y publicado, junto con sus metadatos.</li>
                <li>Tus combos, listas, likes, guardados, comentarios e historial de reproducción.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Plazos</h2>
              <p className="text-gray-600 leading-relaxed">
                La eliminación se completa en un plazo máximo de 30 días desde la confirmación de tu solicitud.
                Podemos conservar determinados datos de forma anonimizada o cuando una obligación legal lo exija
                (por ejemplo, registros de seguridad), durante el plazo legalmente requerido.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Contacto</h2>
              <p className="text-gray-600 leading-relaxed">
                Para cualquier duda sobre este proceso:{' '}
                <a href="mailto:privacy@audiotoo.com" className="text-audioyou-accent hover:underline">
                  privacy@audiotoo.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DeleteAccountPage;
